
export default {
    namespaced: true,
    state: {
        notificaciones: [],
    },
    mutations: {
        SET_NOTIFICACIONES(state, notificaciones){
            state.notificaciones = notificaciones;
        }
    },
    actions: {
        setNotificaciones({commit}, notificaciones){
            commit('SET_NOTIFICACIONES', notificaciones);
        },
    }
}